/* eslint-disable @typescript-eslint/default-param-last */
import { GET_INTERVIEW_CONFIG } from "@/constants/ActionTypes";
import initialState from "@/store/initialState";
import { IInterviewConfigAction } from "@/types/interviewConfig.types";

const interviewConfigReducer = (
  state = initialState.interviewConfig,
  action: IInterviewConfigAction,
) => {
  switch (action.type) {
    case `${GET_INTERVIEW_CONFIG}_SUCCESS`:
      return action.payload.interviewConfig;
    default:
      return state;
  }
};

export default interviewConfigReducer;
